import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import {
    UserTrackableSymptomUpsertRequest,
    TrackableSymptomViewModel
} from "@curefit/gmf-common";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";
import ModelFactory from "../../../models/ModelFactory";
import TemplatedList from "../../TemplatedList";

let SymptomEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "name", display: "Symptoms"},
    {label: "frequency", display: "Frequency"}
];

export interface TrackableSymptomsEditorProps {
    updatedSymptoms: {item: UserTrackableSymptomUpsertRequest}[],
    savedSymptoms: {item: UserTrackableSymptomUpsertRequest}[],
    updateSymptoms: (updatedSymptoms: {item: UserTrackableSymptomUpsertRequest}[]) => void,
    staticTrackableSymptoms: TrackableSymptomViewModel[],
    patientId: number,
    updateSavedSymptoms: (updatedSymptoms: {item: UserTrackableSymptomUpsertRequest}[]) => void
}

export default class TrackableSymptomsEditor extends React.Component<TrackableSymptomsEditorProps> {

    onSymptomChange = (updatedSymptom: UserTrackableSymptomUpsertRequest, index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedSymptoms);
        currUpdatedSymptoms[index] = updatedSymptom;
        this.props.updateSymptoms(currUpdatedSymptoms);
    };

    onSymptomRemove = (index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.updatedSymptoms);
        currUpdatedSymptoms.splice(index, 1);
        this.props.updateSymptoms(currUpdatedSymptoms);
    };

    _handleSavedSymptomRemove = (index: number) => {
        let currUpdatedSymptoms = Object.assign([], this.props.savedSymptoms);
        let symptomToBeDeleted = currUpdatedSymptoms[index];
        symptomToBeDeleted.item.userTrackableSymptomObj.status = "DELETED";
        console.log("--HERE--", symptomToBeDeleted);
    };

    render () {
        return (
            <div className={"trackable-symptoms-editor"}>
                <CustomHeader headerInfos={SymptomEditorHeaderInfos} rootCls={"patient-trackable-symptoms"}/>
                {
                    !_isEmpty(this.props.savedSymptoms) &&
                    <TemplatedList templateName={"trackableSymptom"} commonProps={{staticTrackableSymptoms: this.props.staticTrackableSymptoms}}
                                   defaultItem={{item: ModelFactory.createNewTrackableSymptom()}}
                                   onItemRemove={this._handleSavedSymptomRemove}
                                   autoAddNewRow={false}
                                   preventRowAddition={true}
                                   listItems={this.props.savedSymptoms}/>
                }
                <TemplatedList templateName={"trackableSymptom"} commonProps={{staticTrackableSymptoms: this.props.staticTrackableSymptoms}}
                               defaultItem={{item: ModelFactory.createNewTrackableSymptom()}}
                               listItems={this.props.updatedSymptoms}
                               onItemRemove={this.onSymptomRemove}
                               onItemChange={this.onSymptomChange}/>
            </div>
        )
    }
}